import React from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Text,
} from '@chakra-ui/react';
import { FcGoogle } from 'react-icons/fc';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store/hooks';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle } from '../../utils/awsCognito';
import './SignIn.css';

/**
 * ログイン画面
 */
const SignIn: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthorized } = useAppSelector((state) => state.auth);

  // 認証済みであればホーム画面に戻す
  const navigate = useNavigate();
  if (isAuthorized) {
    navigate('/', { replace: true });
  }

  return (
    <Container
      display="flex"
      flexDir="column"
      justifyContent="center"
      centerContent
      id="signin-view"
    >
      <Box className="signin-grid" />
      <Card
        align="center"
        maxW="2xl"
        w="100vw"
        p={4}
        boxShadow="0 24px 64px rgba(0, 0, 0, 0.45)"
        borderRadius="2xl"
      >
        <CardHeader pb={2}>
          <Box
            fontFamily='"Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif'
            textAlign="center"
            w="100%"
          >
            <Text
              color="#00569c"
              fontSize="45px"
              fontWeight="900"
              fontStyle="italic"
              lineHeight="0.9"
              letterSpacing="-1px"
              m={0}
              p={0}
            >
              {t('features.SignIn.brand.name')}
            </Text>
            <Text
              color="#F57C00"
              fontSize="16px"
              fontWeight="bold"
              fontStyle="italic"
              mt="6px"
            >
              {t('features.SignIn.brand.subtitle')}
            </Text>
          </Box>
        </CardHeader>
        <CardBody w="100%">
          <Button
            w="100%"
            h={16}
            variant="outline"
            leftIcon={<FcGoogle size={24} />}
            bg="white"
            border="solid 1px #000000"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ bg: 'gray.50' }}
            mb={4}
            onClick={signInWithGoogle}
          >
            {t('features.SignIn.button.signInWithGoogle')}
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
};

export default SignIn;
